import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'
import Auth from '@/auth/Auth'
import Eventos from '@/views/Eventos'
import Checkin from '@/views/Checkin'
import Checkout from '@/views/Checkout'
import CriaQRCode from '@/views/CriaQRCode'
import ListaIndicacoes from '@/views/ListaIndicacoes'
import Caixa from '@/views/Pages/Caixa'
import Lojista from '@/views/Pages/Lojista'
import Recargas from '@/views/Recargas'
import Consumos from '@/views/Consumos'
import Cartao from '@/views/Cartao'
import Totem from '@/views/Totem'
import Usuarios from '@/views/Usuarios'
import Consumidores from '@/views/Consumidores'
import Cartoes from '@/views/Cartoes'
import Lojistas from '@/views/Lojistas'
import Resgates from '@/views/Resgates'
import Produtos from '@/views/Produtos'
import Cardapio from '@/views/Cardapio'
import QRCodes from '@/views/QRCodes'
import ConsumosPorItem from '@/views/ConsumosPorItem'
import Fornecedores from '@/views/Fornecedores'
import Categorias from '@/views/Categorias'
import Empresas from '@/views/Empresas'
import Terminais from '../views/Terminais.vue'
import Site from '@/views/Site'
import TemplatesMeta from '@/views/TemplatesMeta'
import Cadastro from '@/views/Pages/Cadastro'
import Faturas from '@/views/Faturas'
import Estoque from '@/views/Estoque'

import { userKey } from '@/global'

Vue.use(VueRouter)

const routes = [
  { name: 'home', path: '/home', component: Home, meta: { requiresAdmin: true } },
  { name: 'auth', path: '/login', component: Auth, meta: { requiresAdmin: false } },
  { name: 'eventos', path: '/eventos', component: Eventos, meta: { requiresAdmin: true } },
  { name: 'cardapio', path: '/cardapio', component: Cardapio, meta: { requiresAdmin: false } },
  { name: 'checkin', path: '/checkin', component: Checkin, meta: { requiresAdmin: true } },
  { name: 'checkout', path: '/checkout', component: Checkout, meta: { requiresAdmin: true } },
  { name: 'criaqrcode', path: '/criaqrcode', component: CriaQRCode, meta: { requiresAdmin: true } },
  { name: 'listaindicacoes', path: '/listaindicacoes', component: ListaIndicacoes, meta: { requiresAdmin: true } },
  { name: 'caixa', path: '/caixa', component: Caixa, meta: { requiresAdmin: true } },
  { name: 'lojista', path: '/lojista', component: Lojista, meta: { requiresAdmin: true } },
  { name: 'recargas', path: '/recargas', component: Recargas, meta: { requiresAdmin: true } },
  { name: 'consumos', path: '/consumos', component: Consumos, meta: { requiresAdmin: true } },
  { name: 'cartao', path: '/', component: Cartao, meta: { requiresAdmin: false } },
  { name: 'totem', path: '/totem', component: Totem, meta: { requiresAdmin: false } },
  { name: 'usuarios', path: '/usuarios', component: Usuarios, meta: { requiresAdmin: true } },
  { name: 'consumidores', path: '/consumidores', component: Consumidores, meta: { requiresAdmin: true } },
  { name: 'cartoes', path: '/cartoes', component: Cartoes, meta: { requiresAdmin: true } },
  { name: 'lojistas', path: '/lojistas', component: Lojistas, meta: { requiresAdmin: true } },
  { name: 'resgates', path: '/resgates', component: Resgates, meta: { requiresAdmin: true } },
  { name: 'qrcodes', path: '/qrcodes', component: QRCodes, meta: { requiresAdmin: true } },
  { name: 'produtos', path: '/produtos', component: Produtos, meta: { requiresAdmin: true } },
  { name: 'consumositem', path: '/consumositem', component: ConsumosPorItem, meta: { requiresAdmin: true } },
  { name: 'fornecedores', path: '/fornecedores', component: Fornecedores, meta: { requiresAdmin: true } },
  { name: 'categorias', path: '/categorias', component: Categorias, meta: { requiresAdmin: true } },
  { name: 'empresas', path: '/empresas', component: Empresas, meta: { requiresAdmin: true } },
  { name: 'Terminais', path: '/terminais', component: Terminais, meta: { requiresAdmin: true } },
  { name: 'site', path: '/site', component: Site, meta: { requiresAdmin: false } },
  { name: 'templatesmeta', path: '/templatesmeta', component: TemplatesMeta, meta: { requiresAdmin: true } },
  { name: 'cadastro', path: '/cadastro', component: Cadastro, meta: { requiresAdmin: false } },
  { name: 'faturas', path: '/faturas', component: Faturas, meta: { requiresAdmin: true } },
  { name: 'estoque', path: '/estoque', component: Estoque, meta: { requiresAdmin: true } },
]

/* const router = new VueRouter({
  routes
}) */

const router = new VueRouter({
  mode: 'history',
  routes
})

//Controla segurança de rotas
router.beforeEach((to, from, next) => {
  const json = sessionStorage.getItem(userKey)
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    const user = JSON.parse(json)
    if (user === "GERENTE" || user === "ADMIN" || user === "CAIXA" || user === "ATENDENTE" || user === 'ADMIN_LOJISTA' || user === 'ADMIN_PRODUTORA')
      next()
    else
      next({ path: '/login' })
  } else {
    next()
  }
})

export default router